import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
declare const BrandVars;

@Component({
	selector: "app-trend-hi",
	templateUrl: "./trend-hi.component.html",
	styleUrls: ["./trend-hi.component.scss"]
})
export class TrendHiComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;
	@Input()
	rul_capacity_factor: number;

	public brand = BrandVars;
	public options?: Highcharts.Options;
	public confidence?: string;
	public errormessage?: string;
	public hasMaintenance: boolean;
	public forceRul = false;
	public rul: number;
	public useXAxisDate = BrandVars.fixedassets;
	public dataExceedsLimit = false;
	public unlimitedChart = false;

	constructor(public api: ApiService, private charting: ChartingService) { }

	async ngOnChanges() {
		await this.RefreshChart();
	}

	public async RefreshChart() {
		if (this.asset && this.component) {
			this.options = undefined;
			this.confidence = undefined;
			this.errormessage = undefined;
			this.hasMaintenance = false;
			this.rul = undefined;
			try {
				const xaxisTitle = this.useXAxisDate ? "Date" : (BrandVars.flightTime + " (hrs)");
				const [hiresult, maintresult] = await Promise.all([
					this.api.GetComponentHi(this.asset.asset_id, this.component.id, 0, this.unlimitedChart ? 1000000 : 15000, this.forceRul),
					this.api.GetMaintenanceHistory(this.asset.asset_id),
				]);
				this.dataExceedsLimit = (hiresult.hi && hiresult.hi.length >= 15000);
				this.rul = hiresult.rul;

				if (maintresult && maintresult.length) {
					this.hasMaintenance = true;
				}

				const series: Highcharts.SeriesLineOptions[] = [];
				if (this.useXAxisDate && hiresult.hi && hiresult.hi.length) {
					for (let i = 0; i < hiresult.hi.length; i++) {
						// Convert dates to ms
						hiresult.hi[i][0] = hiresult.dates[i] * 1000;
						hiresult.filtered[i][0] = hiresult.dates[i] * 1000;
					}
					const lasthi = hiresult.hi[hiresult.hi.length - 1][0];
					if (hiresult.prediction) {
						for (let i = 0; i < hiresult.prediction.predicted.length; i++) {
							hiresult.prediction.predicted[i][0] = lasthi + this.PredictionDate(hiresult.prediction.predicted[i][0]);
							hiresult.prediction.lower[i][0] = lasthi + this.PredictionDate(hiresult.prediction.lower[i][0]);
							hiresult.prediction.upper[i][0] = lasthi + this.PredictionDate(hiresult.prediction.upper[i][0]);
						}
					}
				}
				series.push({ type: "line", name: "HI", data: hiresult.hi });
				if (hiresult.filtered) {
					series.push({ type: "line", name: "Filtered HI", zIndex: 1, data: hiresult.filtered });
				}
				if (hiresult.prediction) {
					series.push({ type: "line", name: "Predicted HI", data: hiresult.prediction.predicted, marker: { enabled: false } });
					series.push({ type: "line", name: "Predicted HI (upper)", data: hiresult.prediction.upper, marker: { enabled: false } });
					series.push({ type: "line", name: "Predicted HI (lower)", data: hiresult.prediction.lower, marker: { enabled: false } });
					if (hiresult.confidence >= 2) {
						this.confidence = "High";
					} else if (hiresult.confidence >= 1) {
						this.confidence = "Medium";
					} else {
						this.confidence = "Low";
					}
				}
				const opt = this.charting.FlightTimeWithMaint("", "", xaxisTitle, this.useXAxisDate, series, hiresult.dates, undefined, "Health", this.fleet ? this.fleet.time_offset_hours : 0, AssemblyConfig.HumsHiThreshold.Warning, AssemblyConfig.HumsHiThreshold.Alarm, maintresult, this.component.lru);
				if (this.useXAxisDate && !Array.isArray(opt.xAxis)) {
					const xaxis: Highcharts.AxisOptions = opt.xAxis;
					xaxis.type = "datetime";
				}
				this.options = opt;
			} catch (err) {
				console.log(err);
				this.errormessage = "Couldn't load HI trend";
			}
		}
	}
	private PredictionDate(base: number): number {
		let result = base * 3600000;
		// Expand for duty cycle if possible
		if (this.rul_capacity_factor > 0) {
			result = result / this.rul_capacity_factor;
		}
		return result;
	}

}
